import SocketClient from 'pages/views/devices/socketClient';
import { STATUS } from 'pages/views/devices/socketClient/types';
import { getHubEnabled } from 'pages/views/devices/utils/storage';
import Logger from 'pages/views/devices/utils/logger';

declare global {
  interface Document {
    mozHidden: boolean;
    webkitHidden: boolean;
    msHidden: boolean;
    onfocusin: () => void;
  }
}

export function onVisibilityChange(callback: (isFocused: boolean) => void) {
  if (!callback) {
    throw new Error('no callback given');
  }

  function focused() {
    if (SocketClient.status !== STATUS.DISCONNECTED || !getHubEnabled()) return;
    Logger.debug('Hub: going to connect socket. Focused.');
    callback(true);
  }

  // Standards:
  if ('hidden' in document) {
    window.document.addEventListener('visibilitychange', () => {
      if (!window.document.hidden) focused();
    });
  } else if ('mozHidden' in document) {
    window.document.addEventListener('mozvisibilitychange', () => {
      if (!document.mozHidden) focused();
    });
  } else if ('webkitHidden' in document) {
    window.document.addEventListener('webkitvisibilitychange', () => {
      if (!document.webkitHidden) focused();
    });
  } else if ('msHidden' in document) {
    window.document.addEventListener('msvisibilitychange', () => {
      if (!document.msHidden) focused();
    });
  }
  // IE 9 and lower:
  else if ('onfocusin' in document) {
    window.document.onfocusin = focused;
  }
  // All others:
  // eslint-disable-next-line no-multi-assign
  window.onpageshow = window.onfocus = focused;
}
